import { render, staticRenderFns } from "./AssignDiscount.vue?vue&type=template&id=1dea69fe&"
import script from "./AssignDiscount.vue?vue&type=script&lang=js&"
export * from "./AssignDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports